import { render, staticRenderFns } from "./coach_view.vue?vue&type=template&id=3a210060&scoped=true"
import script from "./coach_view.vue?vue&type=script&lang=js"
export * from "./coach_view.vue?vue&type=script&lang=js"
import style0 from "./coach_view.vue?vue&type=style&index=0&id=3a210060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a210060",
  null
  
)

export default component.exports